import React from "react";
import { Link } from "react-router-dom";
import { useMenuCategories } from "../hooks/useMenu";

// Fallback data
const fallbackCategories = [
  { id: "1", name: "Hookah", description: "Premium tobacco blends and flavors" },
  { id: "2", name: "Food", description: "Delicious appetizers and main courses" },
  { id: "3", name: "Drinks", description: "Signature cocktails and beverages" }
];

const MenuPreview: React.FC = () => {
  const { data: dbCategories = [] } = useMenuCategories();
  
  // Use database categories if available, otherwise use fallback
  const categories = dbCategories.length > 0 ? dbCategories : fallbackCategories;

  // Category images mapping - fallback to these if no image_url in database
  const defaultCategoryImages: Record<string, string> = {
    'Hookah': '/assets/Hookah Image.png',
    'Food': '/assets/Food Image.png',
    'Drinks': '/assets/Drinks Image.png'
  };

  return (
    <section className="section-padding bg-gradient-to-b from-lounge-dark to-lounge-charcoal">
      <div className="container-custom">
        <h2 className="section-title text-center">Our Menu</h2>
        <p className="section-subtitle text-center max-w-3xl mx-auto">
          Explore our extensive selection of premium hookah flavors, delectable food items, and refreshing beverages.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
          {categories.map((category) => (
            <Link 
              to="/menu" 
              key={category.id} 
              className="relative group rounded-lg overflow-hidden h-96"
            >
              <img 
                src={category.image_url || defaultCategoryImages[category.name] || defaultCategoryImages['Hookah']} 
                alt={category.name} 
                className="w-full h-full object-cover bg-[#18181b] transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 to-transparent flex flex-col justify-end p-6">
                <h3 className="text-2xl font-display font-semibold text-lounge-gold mb-2">{category.name}</h3>
                <p className="text-lounge-light/80 mb-4">{category.description}</p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/menu" className="btn-primary">View Full Menu</Link>
        </div>
      </div>
    </section>
  );
};

export default MenuPreview;
